
import React, { useState } from 'react';
import MonacoEditor from '@monaco-editor/react';
import CompletionPopup from '../completion-popup';
import { serverURL } from '../../config/urls';
import { logEvent } from '@firebase/analytics';
import {analytics} from '../../config/firebase-logging';
import { useCareerContext } from '../career-context';

export function Slicing() {
    const {
        isPopupOpen,
        setIsPopupOpen,
        startConfetti
    } = useCareerContext();
    const options = { scrollbar: { alwaysConsumeMouseWheel: false, }, scrollBeyondLastLine: false, minimap: { enabled: false, } }

    const [code, setCode] = useState(
`def get_data(tag):
    return tag[]`
    );
    const [output, setOutput] = useState('');

    function handleEditorChange(newValue, event) {
        setCode(newValue);
    }

    async function runCode() {
        if (process.env.REACT_APP_ENVIRONMENT === "production") {
            logEvent(analytics, 'career_interaction')
        }
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ code }),
        };
        const response = await fetch(serverURL + "/slicing", requestOptions);
        const result = await response.json();
        if (result.error) {
            setOutput(result.error);
        } else if (result.verdict === "Fail") {
            setOutput(`Test get_data("${result.test}") failed.\nExpected: "${result.expected}", got "${result.result}" instead`)
        } else {
            setOutput("");
            setIsPopupOpen(true);
            startConfetti();
        }
    }

    function hidePopup() {
        setIsPopupOpen(false);
    }


    return (
        <>
            {isPopupOpen && <CompletionPopup title="Great Job!" message="That was a tough one, but you got it!" hidePopup={hidePopup} />}

            <h2 className='blue'>Analyzing Public Opinion</h2>
            <p>
                You are now working for CNN as a SWE! You are tasked with analyzing the public's opinion on the new president. Data has been scraped from relevant forum websites. Websites are structured in HTML, which has different tags that wrap the page's content. Complete the function <code>get_data(tag)</code>, where you are given <code>tag</code>, an html p (paragraph) tag and return the text inside the tag; P tags always follow this format: <code>&lt;p&gt;Some text here&lt;/p&gt;</code>. Most of the code has been written, just fill in the slicing part!  
            </p>
            <p>Examples</p>
            <ul>
                <li><code>get_data(<span className='string'>"&lt;p&gt;this clown has no idea what he's talkin about&lt;/p&gt;"</span>)</code> returns <code><span className='string'>"this clown has no idea what he's talkin about"</span></code></li>
                <li><code>get_data(<span className='string'>"&lt;p&gt;The new bill is looking really promising!&lt;/p&gt;"</span>)</code> returns <code><span className='string'>"The new bill is looking really promising!"</span></code></li>
                <li><code>get_data(<span className='string'>"&lt;p&gt;nice one, idiot&lt;/p&gt;"</span>)</code> returns <code><span className='string'>"nice one, idiot"</span></code></li>
            </ul>

            <div className='row' style={{ alignItems: "flex-start" }}>
                <div style={{ width: (output) ? "50%" : "100%" }}>
                    <div className='editor-padding'></div>
                    <MonacoEditor theme='vs-dark' language='python' height="100px" value={code} onChange={handleEditorChange} options={options} />
                    <button className='primary-btn blue-bg' style={{ marginTop: "5px" }} onClick={runCode}>Submit</button>
                </div>
                
                {output && <pre className='output' style={{ height: "100px" }}>{output}</pre>}

            </div>
        </>
    );
}

